import React from "react";
import CustomInput from "../../../components/CustomForm/CustomInput";
import CustomButton from "../../../components/CustomButton/CustomButton";
import {
  FormWrapper,
  Form,
  FormGroup,
} from "../../../components/CustomForm/FormStyles";

import Colors from "../../../themes/Colors";

import CustomSelect from "../../../components/CustomForm/CustomSelect";
import CustomSeparator from "../../../components/Common/CustomSeparator";

const BusquedaPacienteForm = ({
  documento,
  tipoDocumentoOptions,
  tipoDocumento,
  numeroIngreso,
  codigoPersonaHospitalizada,
  fechaIngreso,
  fechaSalida,
  onStateChange,
  onClean,
  onSearch,
  isLoading,
}) => {
  const selectedTipoDocumento = tipoDocumentoOptions.find(
    (option) => option.value === tipoDocumento
  );

  const tipoDocumentoLabel =
    selectedTipoDocumento.value !== ""
      ? selectedTipoDocumento.label
      : "Documento";

  const tipoDocumentoPlaceholder = tipoDocumentoLabel;

  return (
    <FormWrapper borderColor={Colors.transparent} testid="busqueda-form-wrapper">
      <Form justifyContent={"space-between"} testid="busqueda-form">
        <FormGroup testid="form-group-tipo-documento">
          <CustomSelect
            options={tipoDocumentoOptions}
            label="Tipo de documento"
            isLabelWithContainer={true}
            labelWidth="270px"
            width="272.5px"
            defaultValue=""
            value={tipoDocumento}
            onChange={onStateChange("tipoDocumento")}
            disabled={isLoading}
            testid="select-tipo-documento"
          />
        </FormGroup>
        <FormGroup testid="form-group-documento">
          <CustomInput
            type="number"
            placeholder={`Número de ${tipoDocumentoPlaceholder}`}
            label={`Número de ${tipoDocumentoLabel}`}
            isLabelWithContainer={true}
            labelWidth="270px"
            width="250px"
            value={documento}
            disabled={tipoDocumento === "" || isLoading}
            onChange={onStateChange("documento")}
            testid="input-documento"
          />
        </FormGroup>
        <FormGroup testid="form-group-numero-ingreso">
          <CustomInput
            type="number"
            placeholder="Número de ingreso"
            label="Número de ingreso"
            isLabelWithContainer={true}
            labelWidth="270px"
            width="250px"
            value={numeroIngreso}
            onChange={onStateChange("numeroIngreso")}
            disabled={isLoading}
            testid="input-numero-ingreso"
          />
        </FormGroup>
        <FormGroup testid="form-group-numero-afiliado">
          <CustomInput
            type="number"
            placeholder="Número de asegurado/afiliado"
            label="Número de asegurado/afiliado"
            isLabelWithContainer={true}
            labelWidth="270px"
            width="250px"
            value={codigoPersonaHospitalizada}
            onChange={onStateChange("codigoPersonaHospitalizada")}
            disabled={isLoading}
            testid="input-numero-afiliado"
          />
        </FormGroup>
        <FormGroup testid="form-group-fecha-ingreso">
          <CustomInput
            type="date"
            placeholder="Fecha de ingreso"
            label="Fecha de ingreso"
            isLabelWithContainer={true}
            labelWidth="270px"
            width="250px"
            value={fechaIngreso}
            onChange={onStateChange("fechaIngreso")}
            disabled={isLoading}
            testid="input-fecha-ingreso"
          />
        </FormGroup>
        <FormGroup testid="form-group-fecha-egreso">
          <CustomInput
            type="date"
            minDate={fechaIngreso}
            placeholder="Fecha de egreso"
            label="Fecha de egreso"
            isLabelWithContainer={true}
            labelWidth="270px"
            width="250px"
            value={fechaSalida}
            onChange={onStateChange("fechaSalida")}
            disabled={!fechaIngreso || isLoading}
            required={!!fechaIngreso}
            testid="input-fecha-egreso"
          />
        </FormGroup>
        <FormGroup flexDirection="row" testid="form-group-buttons">
          <CustomButton
            label={"Buscar"}
            onClick={onSearch}
            isLoading={isLoading}
            height={"46px"}
            width={"100px"}
            disabled={isLoading}
            testid="btn-buscar"
          />
          <CustomSeparator width={"10px"} testid="separator-buttons" />
          <CustomButton
            label={"Limpiar"}
            onClick={onClean}
            isLoading={isLoading}
            height={"46px"}
            width={"100px"}
            disabled={isLoading}
            testid="btn-limpiar"
          />
        </FormGroup>
      </Form>
    </FormWrapper>
  );
};

export default BusquedaPacienteForm;
